var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-section-container"},[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }